export default __webpack_public_path__ + "static/media/mobile_skoly_img.277b93d0.png";